import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getConvertCurrency = createAsyncThunk(
  'convertCurrency/getConvertCurrency',
  async ({ fromCurrency, toCurrency, amount, date }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/convert-currency?from=${fromCurrency}&to=${toCurrency}&amount=${amount}&date=${date}`,
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);
